// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAfjtY9_07yibVW53TcMfuj5dttEgNDi2U",
    authDomain: "simple-firebase-authenti-4d5cc.firebaseapp.com",
    projectId: "simple-firebase-authenti-4d5cc",
    storageBucket: "simple-firebase-authenti-4d5cc.appspot.com",
    messagingSenderId: "747247259033",
    appId: "1:747247259033:web:7029171ef3e3d22c3e5708"
  };

  export default firebaseConfig;